import styled from 'styled-components'

export const Container = styled.div`
  margin: 0 0 100px;
`
